import React, { useEffect, useState } from 'react';
import classes from './styles.module.scss';
import { useNavigate, useParams } from 'react-router-dom';
import { APIProvider } from '@vis.gl/react-google-maps';
import { useUser } from '../../contexts/user.context';
import { oblast } from '../../consts/kato.conts';
import { getKatoType } from '../../helpers/utils';
import { KatoType } from '../../types/kato.types';
import { useKato } from '../../contexts/kato.context';
import LeftMenu from './components/left-menu/left-menu.component';
import RightMenu from './components/right-menu/right-menu.component';
import MapComponent from './components/map/map.component';

const HomePage = () => {
  const navigate = useNavigate();
  const { kato, tab, link } = useParams<{
    kato: string;
    tab: string;
    link: string;
  }>();
  const { user } = useUser();
  const {
    katoTree,
    setCurrentLevel,
    setSelectedRegion,
    setSelectedDistrict,
    setSelectedVillage,
    updatedGeneralInfo,
  } = useKato();

  const [showRightMenu, setShowRightMenu] = useState(false);

  useEffect(() => {
    if (!user || !kato) return;

    const katoNum = +kato;
    const katoType = getKatoType(kato);
    const isAllowed =
      user.kato_access.includes(katoNum) || user.kato_access.includes(0);

    if (!isAllowed) {
      navigate(`/${user.kato_access[0] || oblast.kato}`, { replace: true });
      return;
    }

    const regionCode = kato.slice(0, 4);
    const region = katoTree.find((r) =>
      r.kato.toString().startsWith(regionCode),
    );
    if (!region) return;

    switch (katoType) {
      case KatoType.OBLAST:
        setCurrentLevel(KatoType.OBLAST);
        break;

      case KatoType.REGION:
        setCurrentLevel(KatoType.REGION);
        setSelectedRegion(region);
        break;

      case KatoType.DISTRICT: {
        const district = region.children?.find((d) => d.kato === katoNum);
        if (district) {
          setCurrentLevel(KatoType.DISTRICT);
          setSelectedDistrict(district);
        }
        break;
      }

      case KatoType.VILLAGE: {
        const districtCode = kato.slice(0, 6);
        const district = region.children?.find((d) =>
          d.kato.toString().startsWith(districtCode),
        );
        const village = district?.children?.find((v) => v.kato === katoNum);
        if (village) {
          setCurrentLevel(KatoType.VILLAGE);
          setSelectedVillage(village);
        }
        break;
      }
    }
  }, [kato, user]);

  useEffect(() => {
    setShowRightMenu(true);
  }, [tab, link, kato]);

  return (
    <APIProvider
      apiKey="AIzaSyAxmMmhtOS246hyOpM1qSJZtBY5dTF_Tao"
      language="ru"
      libraries={['places']}
    >
      <div className={classes.home}>
        <LeftMenu />
        {showRightMenu && link && <RightMenu setIsOpen={setShowRightMenu} />}
        <MapComponent
          setSelectedRegion={setSelectedRegion}
          setSelectedVillage={setSelectedVillage}
        />
      </div>
    </APIProvider>
  );
};

export default HomePage;
